export default {"src":"/_next/static/media/company-news-link-icon.ee3a69c6.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};